import { render, staticRenderFns } from "./PostoColetaExamesComponente.vue?vue&type=template&id=7cf04d3c&scoped=true"
import script from "./PostoColetaExamesComponente.vue?vue&type=script&lang=js"
export * from "./PostoColetaExamesComponente.vue?vue&type=script&lang=js"
import style0 from "./PostoColetaExamesComponente.vue?vue&type=style&index=0&id=7cf04d3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cf04d3c",
  null
  
)

export default component.exports